<template>
  <el-popover placement="top-start"
              width="300" v-if="tasks.length>0"
              trigger="hover">
    <div slot="reference" class="flex-cm work-act-single white-font font-size14">
      <div  class="botton-content flex-cm only-click-button bg-green white-font">
        <img src="https://assets.pfotoo.com/pc/img/output.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
        <span>导出评选数据</span>
      </div>
    </div>
    <div style="cursor: pointer;max-height: 75vh;overflow-y: auto;">
      <div style="margin: 10px 0;" v-for="task in tasks">
        <el-link class="flex-lt black-font font-size14 font-bold" style="padding-bottom:5px;font-weight: bold"
                 @click="downexcel(task)">
          <span>[{{['','打分','投票','点评'][task.chooseType]}}] {{task.name}} <span class="gray-font">({{task.submissionCount}}投稿)</span></span>
        </el-link>
      </div>
    </div>
  </el-popover>
</template>

<script>
  import App from '../../util/comfun'
  export default {
    props:{
      activityId:{
        type:String,
        value:''
      },
    },
    watch:{
      activityId(newV,oldV){
        this.getList()
      },
    },
    data () {
      return {
        tasks:[],
      }
    },
    methods:{
      downexcel(task){
        const loading = this.$loading({
          lock: true,
          text: '数据准备中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        App.demand('/choose/exportChooseExcel','GET',{taskId:task.id,t:Math.random()}).then(data=>{
          loading.close();
          //let blob = new Blob([data], {type: "application/vnd.ms-excel"});
          let blob = new Blob([data], {type: "application/vnd.ms-excel"})
          //let blob = new Blob([data]);
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', task.name+'.xlsx')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
      },
      getList(){
        App.demand('/choose/task/queryList','POST',{
          activityId: this.activityId,
          pageIndex: 1,
          pageSize: 300,
        }).then(res=>{
          this.tasks=res.data.taskList||[]
        })
      },
    },
    mounted(){
      this.getList();
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/election/index.vue